export default class User {
    constructor(box21_api) {
        this.api = box21_api;
        this._limitsCache = null;
    }

    async add_to_project(user) {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('project_id', sessionStorage.getItem('project_id'));
        return this.api.post_with_token('/user/add-to-project', formData)
    }

    async reset_password(email, password, password_confirmation, token  = null) {
        let formData = new FormData();
        formData.append('email', email);
        formData.append('password', password);
        formData.append('password_confirmation', password_confirmation);
        formData.append('token', token);
        return this.api.post_with_token('/user/reset-password', formData)
    }

    async initiate_reset_password(email  = null) {
        let formData = new FormData();
        formData.append('email', email);
        return this.api.post_with_token('/user/initiate-reset-password', formData)
    }

    async join_waiting_list(email, project_description) {
        let formData = new FormData();
        formData.append('email', email);
        formData.append('username', email);
        formData.append('first_name', '');
        formData.append('last_name', '');
        formData.append('project_description', project_description);
        return this.api.post_with_token('/user/register', formData)
    }

    async add(user) {
        let formData = new FormData();
        formData.append('email', user.email);
        formData.append('username', user.username);
        formData.append('first_name', user.first_name);
        formData.append('last_name', user.last_name);
        formData.append('password', user.password);
        formData.append('project_id', sessionStorage.getItem('project_id'));
        return this.api.post_with_token('/users/add', formData)
    }

    async find_users(email) {
        let formData = new FormData();
        formData.append('email', email);
        return this.api.post_with_token('/users/find', formData)
    }

    async change_password(current_password, new_password) {
        let formData = new FormData();
        formData.append('password', current_password);
        formData.append('new_password', new_password);
        return this.api.post_with_token('/user/update_password', formData);
    }

    async update_avatar(properties) {
        let formData = new FormData();
        formData.append('json_avatar_properties', JSON.stringify(properties));
        return this.api.post_with_token('/user/patch', formData);
    }

    async delete(user) {
        let formData = new FormData();
        formData.append('project_id', sessionStorage.getItem('project_id'));
        formData.append('user_id', user.id);
        return this.api.post_with_token('/delete-user', formData);
    }

    async all_for_project(project_id) {
        let formData = new FormData();
        formData.append('project_id', project_id);
        return this.api.post_with_token('/users', formData)
    }

    async all() {
        let formData = new FormData();
        formData.append('project_id', sessionStorage.getItem('project_id'));
        return this.api.post_with_token('/users', formData)
    }

    async get_limits(forceRefresh = false) {
        // Return cached limits if available and not forcing refresh
        if (this._limitsCache && !forceRefresh) {
            return Promise.resolve(this._limitsCache);
        }
        
        // Fetch and cache the limits
        const limits = await this.api.post_with_token('/user/get_limits');
        this._limitsCache = limits;
        return limits;
    }

    clearLimitsCache() {
        this._limitsCache = null;
    }

    async set_or_delete_user_2fa_secret_key() {
        let formData = new FormData();
        return this.api.post_with_token('/user/set_or_delete_user_2fa_secret_key', formData);
    }

    async get_2fa_secret_key() { 
        let formData = new FormData();   
        return this.api.post_with_token('/user/get_2fa_secret_key', formData);
    }

    async verify_2fa_secret_key_otp(secret_key, otp) {
        let formData = new FormData();
        formData.append('secret_key', secret_key)
        formData.append('otp', otp)
        return this.api.post_with_token('/user/verify_2fa_secret_key_otp', formData);
    }

    async store_2fa_secret_key(secret_key) {
        let formData = new FormData();
        formData.append('secret_key', secret_key)
        return this.api.post_with_token('/user/store_2fa_secret_key', formData);
    }

    async delete_2fa_secret_key(secret_key) {
        let formData = new FormData();
        formData.append('secret_key', secret_key)
        return this.api.post_with_token('/user/delete_2fa_secret_key', formData);
    }

    async user_2fa_enabled_login(email) {
        let formData = new FormData();
        formData.append('email', email)
        return this.api.post_without_token('/user/2fa_enabled_login', formData);
    }

    async verify_2fa_secret_key_email(otp, email) {
        let formData = new FormData();
        formData.append('email', email)
        formData.append('otp', otp)
        return this.api.post_without_token('/user/verify_2fa_secret_key_email', formData);
    }

    async user_2fa_enabled_profile() {
        let formData = new FormData();
        return this.api.post_with_token('/user/2fa_enabled_profile', formData);
    }

    async check_confirmation_status(email) {
        let formData = new FormData();
        formData.append('email', email)
        return this.api.post_without_token('/user/check_confirmation_status', formData);
    }  

    async get_user_limits() {
        let formData = new FormData();
        return this.api.post_with_token('/overview/get-user-limits', formData)
    }

    async get_trusted_devices() {
        return this.api.post_with_token('/user/trusted-devices')
    }

    async revoke_trusted_device(device_id) {
        let formData = new FormData();
        formData.append('device_id', device_id);
        return this.api.post_with_token('/user/trusted-devices/revoke', formData)
    }

    async revoke_all_trusted_devices() {
        return this.api.post_with_token('/user/trusted-devices/revoke-all')
    }

    async validate_trusted_device() {
        return this.api.post_without_token('/user/trusted-devices/validate')
    }

}